import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@getnuvo/importer-react'

export const headerSelect: ThemeAPI['headerSelect'] = {
  root: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.dimensions.s8,
  },
  pageHeader: {
    title: {
      display: 'none',
    },
    description: {
      color: theme.colors.grey800,
      fontSize: theme.fontSizes[100],
    },
  },
  content: {
    fontSize: theme.fontSizes[100],
    color: theme.colors.grey800,
  },
  sheetName: {
    root: {
      backgroundColor: theme.colors.white,
      borderRadius: theme.dimensions.s8,
      padding: theme.dimensions.s16,
    },
    title: {},
    description: {
      color: theme.colors.grey800,
      fontSize: theme.fontSizes[100],
    },
    border: {
      backgroundColor: theme.colors.radicalRed600,
    },
  },
  fullScreen: {
    root: {
      width: theme.dimensions.s200,
    },
  },
  table: {
    selectRowColor: '#eaf2fa',
  },
  sheetNameSelected: {
    root: {
      backgroundColor: theme.colors.white,
      borderRadius: theme.dimensions.s8,
    },
    title: {
      color: theme.colors.grey1000,
    },
    description: {
      color: theme.colors.grey600,
    },
    border: {
      backgroundColor: theme.colors.grey000White,
    },
  },
}
